export const SPREADSHEET_CELL_DATA_UPDATE = 'SPREADSHEET_CELL_DATA_UPDATE';
